import { Grid, Typography, Avatar, useMediaQuery, useTheme } from "@material-ui/core"
import './StaffSelection.css'
import LightTooltip from "../LightTooltip/LightTooltip"
const CaritraWidgetStaffSelection = (props) => {
    const { setStaffIndex, staffIndex, widgetInfo } = props
    const mobile = useMediaQuery(`(max-width: 37.5rem)`)
    if (mobile) {
        return (
            <div>
                <Typography className="CaritraWidgetStaffSelectionTitle">
                    <b>Select Instructor</b>
                </Typography>
                <Grid container className="CaritraWidgetStaffSelectionContainer">
                    {widgetInfo.staffDetails.map((staff, index) => {
                        const new_props = {
                            key: `staff_mobile_${index}`,
                            staff,
                            selected: index === staffIndex,
                            handleClick: () => { setStaffIndex(index) }
                        }
                        return <StaffButtonMobile {...new_props} />

                    })}
                </Grid>
            </div>
        )
    }
    else {
        return (
            <div>
                <Typography className="CaritraWidgetStaffSelectionTitle" >
                    <b>Select Instructor</b>
                </Typography>
                <Grid container className="CaritraWidgetStaffSelectionContainer" wrap="nowrap">
                    {widgetInfo.staffDetails.map((staff, index) => {
                        const new_props = {
                            key: `staff_desktop_${index}`,
                            staff,
                            selected: index === staffIndex,
                            handleClick: () => { setStaffIndex(index) }
                        }
                        return <StaffButtonDesktop {...new_props} />

                    })}
                </Grid>
            </div>
        )
    }
}


const StaffButtonMobile = (props) => {
    const { staff, selected, handleClick } = props
    return (
        <Grid item xs={12} className="CaritraWidgetStaffSelectionButtonWrapper">
            <Grid container alignItems="center" wrap="nowrap">
                <Grid item>
                    <Avatar
                        onClick={handleClick}
                        src={staff.image}
                    />
                </Grid>
                <Grid item>
                    <LightTooltip arrow title={`${staff.firstName} ${staff.lastName}`}>
                        <Typography noWrap className="CaritraWidgetStaffSelectionButtonName">
                            {
                                selected ?
                                    <b onClick={handleClick}>{`${staff.firstName} ${staff.lastName}`}</b>
                                    :
                                    <span onClick={handleClick}>{`${staff.firstName} ${staff.lastName}`}</span>
                            }
                        </Typography>
                    </LightTooltip>
                </Grid>
            </Grid>
        </Grid>
    )
}



const StaffButtonDesktop = (props) => {
    const { staff, selected, handleClick } = props
    const theme = useTheme();
    return (
        <Grid item className="CaritraWidgetStaffSelectionButtonWrapper">

            {
                selected ?
                    <svg
                        viewBox="0 0 25 25"
                        className="CaritraWidgetStaffSelectionCheck"
                        style={{ fill: theme.palette.secondary.main, backgroundColor: theme.palette.primary.main }}
                    >
                        <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
                    </svg>
                    : null
            }
            <Avatar
                onClick={handleClick}
                className={`CaritraWidgetStaffSelectionAvatar${selected ? " CaritraWidgetStaffSelectionAvatarSelected" : ""}`}
                alt={`${staff.firstName} ${staff.lastName}`}
                src={staff.image}
                style={selected ? {
                    opacity: 1,
                    border: `0.125rem solid ${theme.typography.body1.color}`,
                } : {}}
            />

            <LightTooltip arrow title = {`${staff.firstName} ${staff.lastName}`}>
                <Typography align="center" noWrap className="CaritraWidgetStaffName">
                    {selected ?
                        <b>{`${staff.firstName} ${staff.lastName}`}</b>
                        : `${staff.firstName} ${staff.lastName}`}
                </Typography>
            </LightTooltip>
        </Grid>
    )
}

export default CaritraWidgetStaffSelection